import React from 'react'
import { ImageGallery } from '@heimr/react-image-gallery'
import '@heimr/react-image-gallery/style.css'

import Layout from 'components/Layout'

const Gallery = ({ children, heading, query, captions = true }) => (
  <Layout pageTitle={heading} headerText={heading} galleryPage={true}>
    <oma-grid-row>
      <section className='article__content page__column'>{children}</section>
    </oma-grid-row>
    <oma-grid-row>
      <section className='article__content page__column'>
        <ImageGallery query={query} captions={captions} />
      </section>
    </oma-grid-row>
  </Layout>
)

export default Gallery
